import {
  SymbolEditor,
  useContentAttach,
} from '@components/App/Modal/BlockModal'
import type { SymbolItem } from '@octopus-do/octopus-project-core'
import type React from 'react'

import { ModalHeader } from '../components/ModalHeader'
import css from './Symbol.module.scss'

type Props = {
  symbol: SymbolItem
  onClose: () => void
}

export const SymbolModal: React.FC<Props> = ({ symbol, onClose }) => {
  const { onUpload } = useContentAttach()

  return (
    <div className={css.wrapper}>
      <div className={css.content}>
        <ModalHeader
          color="var(--color-code-blue-11)"
          title="Page"
          onClose={onClose}
        />

        {symbol && (
          <div className={css.contain}>
            <SymbolEditor readonly={false} onUpload={onUpload} id={symbol.id} />
          </div>
        )}
      </div>
    </div>
  )
}
